/* Universal javascript */
import '../css/app.css';
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import jsResizeAnimationStopper from './utils/resizeAnimationStopper.js'
import swiper from './components/swiper.js'
import lightbox from './components/lightbox.js'
import htmxEvents from './components/htmxEvents.js'
import datePicker from './components/datePicker.js'
import addToCalendar from './components/addToCalendar.js'
import share from './components/share.js'

// Get any third-party libraries
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

// Delay init of lazyloading plugin
const lazySizesConfig = lazySizes.cfg;
lazySizesConfig.init = false;

// Init Alpine
window.Alpine = Alpine;
Alpine.plugin(focus);

/* Init our components that don't rely on content that gets injected dynamically via Blitz,
meaning that this content CAN (and maybe SHOULD) be cached. So, not user dropdowns or cards,
which incorporates a user-based Favorites functionality. */
Alpine.start();


// Spoof Blitz loading event, in case of environments with Blitz disabled
let hasBlitz = main.dataset.hasBlitz;
if (hasBlitz == 'no-blitz') {
    console.log('noBlitz');

    const event = new Event('afterBlitzInjectAll');
    document.dispatchEvent(event);
}

/* Init our un-cache-able components */
document.addEventListener('afterBlitzInjectAll', function(event) {
    console.log('afterBlitzInjectAll');

    htmxEvents.init();
    datePicker.init();
    addToCalendar.init();
    share.init();
    lightbox.init();
    lazySizes.init();
    jsResizeAnimationStopper.init();
    swiper.init();
});
